import { BrowserRouter, Routes, Route } from "react-router-dom";
import Home from "./pages/Home";
import Writing from "./pages/Writing";
import PostPage from "./pages/PostPage";
import Resume from "./pages/Resume";
import NotFound from "./pages/NotFound";
import "./styles/tokens.css";
import ScrollToTop from "./hooks/useScrollToTop";

export default function App() {
  return (
    <BrowserRouter>
      <Routes>
        <Route path="/" element={<Home />} />
        <Route path="/writing" element={<Writing />} />
        <Route path="/writing/:slug" element={<PostPage />} />
        <Route path="/resume" element={<Resume />} />
        <Route path="*" element={<NotFound />} />
      </Routes>
      <ScrollToTop />
    </BrowserRouter>
  );
}
